import * as React from "react";
import * as Flex from "@twilio/flex-ui";

export class HandleWrappingChat extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            taskStatus: null, 
            timerSinceTaskUpdate: null
        };
    }

    completeTask = (thisTask, thisTaskSid) => {
        Flex.Actions.invokeAction("CompleteTask", {
            task: thisTask,
            taskSid: thisTaskSid,
            reason: 'completing wrapped up task'
        });

        clearInterval(this.handleWrappingInterval);
    }

    checkTaskStatus = (props) => {
        this.setState({timerSinceTaskUpdate: new Date().toLocaleString()});         

        //only allow tasks to auto-close if they are in the wrapping state and is not being barged by the supervisor.
        if(this.props.task.taskStatus === "wrapping" && (this.props.task.attributes?.isBargedOn == null))
        {
            var today = new Date();
            var taskUpdateDate = new Date(props.task.dateUpdated);
            var diffMins = Math.round((((taskUpdateDate - today) % 86400000) % 3600000) / 60000); // minutes

            if(this.state.timerSinceTaskUpdate >= 300000 || Math.abs(diffMins) > 5)
            {
                const taskSid =  props.task.taskSid ?? props.task.source?.sid ?? ""
                this.completeTask(props.task, taskSid);
            }
        }            
    }

    render(){
        const shouldSetTaskStatus = this.props?.task?.taskStatus != null 
            && this.props?.task?.dateUpdated != null 
            && this.props?.task?.attributes?.isBargedOn == null
            && this.state.taskStatus !== this.props?.task?.taskStatus 
            && this.props?.task?.taskStatus === "wrapping"

        if(shouldSetTaskStatus)
        {
            this.handleWrappingInterval = setInterval(() => this.checkTaskStatus(this.props), 1000);
            this.setState({
                taskStatus: this.props.task.taskStatus
            });
        }
        
        return null;
    }
}